/* eslint-disable import/no-duplicates */
import ChurnNightingaleAllFilter from '@/pages/dashboard/filterPageComponents/engagement/churnNightingaleAllFilter';
import WeekChurnUsersNightingaleContext from "@/pages/dashboard/pages/engagement/churn/Nightingale/component/WeekChurnUsersNightingaleContext";
import ChurnLevelDisContext from "@/pages/dashboard/pages/engagement/churn/Nightingale/component/ChurnLevelDisContext";
import ActiveUsersFilter from '@/pages/dashboard/filterPageComponents/engagement/activeUsersFilter';
import ActiveOnlineFilter from '@/pages/dashboard/filterPageComponents/engagement/activeOnlineFilter';
import ActiveDegreeFilter from '@/pages/dashboard/filterPageComponents/engagement/activeDegreeFilter';
import ActiveUsersTrendCo from '@/pages/dashboard/pages/engagement/active/components/ActiveUsersTrendCo';
import ActiveUsersCardCo from '@/pages/dashboard/pages/engagement/active/components/ActiveUsersCardCo';
import RetentionNightingaleFilter from '@/pages/dashboard/filterPageComponents/engagement/retentionNightingaleFilter';
import RetentionMobileFilter from '@/pages/dashboard/filterPageComponents/engagement/retentionMobileFilter';
import NightingaleLineChartCo from '@/pages/dashboard/pages/engagement/retention/components/NightingaleLineChartCo';
import RetentionChartContentCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionChartContentCo';
import RetentionTableCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTableCo';
import DAULevelDistributionCo from '@/pages/dashboard/pages/engagement/active/components/DAULevelDistributionCo';
import AveragePlaytimeTrendCo from '@/pages/dashboard/pages/engagement/active/components/AveragePlaytimeTrendCo';
import AveragePlaytimeDistributionCo from '@/pages/dashboard/pages/engagement/active/components/AveragePlaytimeDistributionCo';
import AveragePlaytimeByLevelCo from '@/pages/dashboard/pages/engagement/active/components/AveragePlaytimeByLevelCo';
import WeeklyActiveUsersServiceCo from '@/pages/dashboard/pages/engagement/active/components/WeeklyActiveUsersServiceCo';
import LoginActiveUsersCo from '@/pages/dashboard/pages/engagement/active/components/LoginActiveUsersCo';
import ActiveUsersDaysCo from '@/pages/dashboard/pages/engagement/active/components/ActiveUsersDaysCo';
import ActiveUsersActivityCo from '@/pages/dashboard/pages/engagement/active/components/ActiveUsersActivityCo';
import ActiveDegreeContentCo from '@/pages/dashboard/pages/engagement/active/components/ActiveDegreeContentCo';
import ReturnV2Filter from '@/pages/dashboard/filterPageComponents/engagement/returnV2Filter';
import NewFilter from '@/pages/dashboard/filterPageComponents/engagement/newFilter';
import TotalNewUsersCo from '@/pages/dashboard/pages/engagement/new/components/TotalNewUsersCo';
import ReturnFilter from '@/pages/dashboard/filterPageComponents/engagement/returnFilter';
import ReturnTrendCo from '@/pages/dashboard/pages/engagement/return/components/ReturnTrendCo';
import RollingRetentionFilter from '@/pages/dashboard/filterPageComponents/engagement/rollingRetentionFilter';
import NewUsersTrendCo from '@/pages/dashboard/pages/engagement/new/components/NewUsersTrendCo';
import NewUsersDistributionCo from '@/pages/dashboard/pages/engagement/new/components/NewUsersDistributionCo';
import RetentionTrendCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTrendCo';
import RetentionReturnTableCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionReturnTableCo';
import ChurnAllFilter from '@/pages/dashboard/filterPageComponents/engagement/churnAllFilter';
import ChurnAllUserService from '@/pages/dashboard/pages/engagement/churn/components/ChurnAllUserService';
import ChurnUsersCo from '@/pages/dashboard/pages/engagement/churn/components/ChurnUsersCo';
import ChurnNewFilter from '@/pages/dashboard/filterPageComponents/engagement/churnNewFilter';
import ChurnUsersOnlineTimeDistributionCo from '@/pages/dashboard/pages/engagement/churn/components/ChurnUsersOnlineTimeDistributionCo';
import ChurnLevelDistributionCo from '@/pages/dashboard/pages/engagement/churn/components/ChurnLevelDistributionCo';
import TableLevelCo from '@/pages/dashboard/pages/engagement/churn/components/TableLevelCo';
import TrackingDayCo from '@/pages/dashboard/pages/engagement/churn/components/TrackingDayCo';
import NewUsersNightingaleLineChartCo from '@/pages/dashboard/pages/engagement/retention/components/NightingaleLineChartCo';
import ActiveUsersNightingaleLineChartCo from '@/pages/dashboard/pages/engagement/retention/components/NightingaleLineChartCo';
import NewUsersRetentionTrendCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTrendCo';
import ActiveUsersRetentionTrendCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTrendCo';
import ReturnUsersRetentionTrendCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTrendCo';
import RetentionReturnUsersRetentionTrendCo from '@/pages/dashboard/pages/engagement/retention/components/RetentionTrendCo';

export default {
  ChurnNightingaleAllFilter,
  WeekChurnUsersNightingaleContext,
  ChurnLevelDisContext,
  ActiveUsersFilter,
  ActiveOnlineFilter,
  ActiveDegreeFilter,
  ActiveUsersTrendCo,
  ActiveUsersCardCo,
  RetentionNightingaleFilter,
  RetentionMobileFilter,
  NightingaleLineChartCo,
  NewUsersNightingaleLineChartCo,
  ActiveUsersNightingaleLineChartCo,
  ReturnUsersRetentionTrendCo,
  RetentionChartContentCo,
  RetentionTableCo,
  RetentionTrendCo,
  NewUsersRetentionTrendCo,
  ActiveUsersRetentionTrendCo,
  RetentionReturnUsersRetentionTrendCo,
  RetentionReturnTableCo,
  DAULevelDistributionCo,
  AveragePlaytimeTrendCo, 
  AveragePlaytimeDistributionCo,
  AveragePlaytimeByLevelCo,
  WeeklyActiveUsersServiceCo,
  LoginActiveUsersCo,
  ActiveUsersDaysCo,
  ActiveUsersActivityCo,
  ActiveDegreeContentCo,
  ReturnV2Filter,
  NewFilter,
  TotalNewUsersCo,
  NewUsersTrendCo,
  ReturnFilter,
  ReturnTrendCo,
  NewUsersDistributionCo,
  RollingRetentionFilter,
  ChurnAllFilter,
  ChurnAllUserService,
  ChurnUsersCo,
  ChurnNewFilter,
  ChurnUsersOnlineTimeDistributionCo,
  ChurnLevelDistributionCo,
  TableLevelCo,
  TrackingDayCo
};
